import { createContext } from 'react';
import { appInitialState } from './store/reducer';

const AppContext = createContext(appInitialState);

export default AppContext;
